import * as React from 'react';
import { LibColor } from "../../new-libby/core/colors/colors-map";
export var getChevronIcon = function (isDisabled) {
    var iconColor = isDisabled ? LibColor.grey100 : LibColor.blue100;
    return (React.createElement("svg", { width: '9', height: '8', viewBox: '0 0 9 8', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        React.createElement("path", { "fill-rule": 'evenodd', "clip-rule": 'evenodd', d: 'M0.403809 2.25842L1.90896 0.941406L4.65639 4.08132L7.40381 0.941406L8.90896 2.25842L4.65639 7.1185L0.403809 2.25842Z', fill: iconColor })));
};
//# sourceMappingURL=chevron-icon.js.map